// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XvaGSD {
  position: relative;
  display: inline-flex;
}

.kRPunm {
  cursor: pointer;
  transition: color 0.2s ease;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: inline-block;
  align-items: center;
  justify-content: center;
  font: inherit;
  color: inherit;
}

.K7bNIJ {
  position: absolute;
  top: 0;
  left: calc(100% + 8px);
  min-width: 200px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  padding: var(--spacing-1-5) 0 var(--spacing-1-5) var(--spacing-2);
  font-family: var(--font-family-base);
  box-shadow: var(--shadow-sm);
  word-wrap: break-word;
  box-sizing: border-box;
  z-index: 20;
}

.An8qbk {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 130px;
  overflow: auto;
  padding-right: var(--spacing-0-5);
}

.QPk_r6 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-1);
  padding: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  flex-shrink: 0;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorOrderBeneficiaryTooltip/EmissorOrderBeneficiaryTooltip.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B;EAC9B,iEAAiE;EACjE,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.iconTrigger {\n  cursor: pointer;\n  transition: color 0.2s ease;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: inline-block;\n  align-items: center;\n  justify-content: center;\n  font: inherit;\n  color: inherit;\n}\n\n.tooltip {\n  position: absolute;\n  top: 0;\n  left: calc(100% + 8px);\n  min-width: 200px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1-5) 0 var(--spacing-1-5) var(--spacing-2);\n  font-family: var(--font-family-base);\n  box-shadow: var(--shadow-sm);\n  word-wrap: break-word;\n  box-sizing: border-box;\n  z-index: 20;\n}\n\n.tooltipContent {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-height: 130px;\n  overflow: auto;\n  padding-right: var(--spacing-0-5);\n}\n\n.tooltipRow {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-1);\n  padding: 0;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `XvaGSD`,
	"iconTrigger": `kRPunm`,
	"tooltip": `K7bNIJ`,
	"tooltipContent": `An8qbk`,
	"tooltipRow": `QPk_r6`
};
module.exports = ___CSS_LOADER_EXPORT___;
